import { Link } from "react-router-dom";
import { Panel, Eyebrow } from "@/components/mh/bits";
import { Receipt } from "@/components/mh/Receipt";

const STEP_COLOR = { dispatched: "#00E5FF", ok: "#D4FF3A", failed: "#FF3B5C" };
const GATE_COLOR = { yes: "#D4FF3A", unsure: "#FFB020", no_receipt: "#FFB020", blocked: "#FF3B5C", error: "#FF3B5C" };
const CHIP = "min-w-[13rem] max-w-[18rem] flex-1 rounded-lg border bg-white/[0.02] px-3 py-2 mh-enter";

const AgentChip = ({ s, i, t }) => (
  <div className={`${CHIP} border-white/[0.07]`} data-testid={`preflight-step-${s.node_id}`}>
    <div className="font-mono text-[10px] text-muted-foreground">STEP {i + 1}</div>
    <div className="text-sm truncate">{s.agent_name}</div>
    <div className="font-mono text-[11px] mt-0.5 flex items-center gap-1.5">
      <span className="text-muted-foreground">→</span>
      <span className="text-foreground" data-testid={`preflight-agentid-${s.node_id}`}>{t?.agentId || s.agent_id}</span>
      <span style={{ color: s.mapped || s.isolated ? "#6B6B7B" : "#FFB020" }}>{s.mapped ? "mapped" : s.isolated ? "isolated" : "default"}</span>
    </div>
    {!s.tools.ok && <div className="font-mono text-[10px] mt-1 text-[#FF3B5C]" data-testid={`preflight-tools-${s.node_id}`}>no tools connected</div>}
    {t && (
      <div className="font-mono text-[10px] mt-1 truncate" style={{ color: STEP_COLOR[t.status] }} data-testid={`trace-${s.node_id}`} title={t.error || ""}>
        {t.status === "dispatched" ? "running on OpenClaw…" : t.ok ? `done · ${t.runId || "no run id"}` : `failed · ${t.error || "error"}`}
      </div>
    )}
    {t && <Receipt r={t.receipt} compact testId={`trace-receipt-${s.node_id}`} />}
    {t?.ok && !t.receipt && <div className="font-mono text-[10px] mt-1 text-muted-foreground">no receipt yet</div>}
  </div>
);

const GateChip = ({ s, i, t }) => (
  <div className={`${CHIP} border-[#00E5FF]/25`} data-testid={`preflight-step-${s.node_id}`}>
    <div className="font-mono text-[10px] text-[#00E5FF]">STEP {i + 1} · JEV GATE</div>
    <div className="text-xs mt-0.5 line-clamp-2">{s.question || "Default: is the previous result good enough to continue?"}</div>
    <div className="font-mono text-[10px] text-muted-foreground mt-0.5">pass at ≥ {s.threshold}% yes</div>
    {t?.decision && <div className="font-mono text-[10px] mt-1" style={{ color: GATE_COLOR[t.decision] }} data-testid={`gate-decision-${s.node_id}`}>
      {t.decision === "yes" ? "passed · " : "→ human · "}{t.note}</div>}
  </div>
);

export const WorkflowLive = ({ pre, run }) => {
  if (!pre || (pre.runtime !== "openclaw" && !pre.steps.some((s) => s.kind === "gate"))) return null;
  const trace = run?.trace || {};
  const agents = pre.steps.filter((s) => s.kind === "agent").length;
  return (
    <Panel cls="p-4 space-y-3" testId="wf-preflight">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div><Eyebrow>Live route</Eyebrow><span className="text-sm text-muted-foreground">{agents} agent step{agents === 1 ? "" : "s"} across {pre.distinct_agents} OpenClaw agent{pre.distinct_agents === 1 ? "" : "s"}</span></div>
        <Link to="/connections" className="font-mono text-[11px] underline text-muted-foreground hover:text-foreground" data-testid="wf-edit-mapping">Edit mapping →</Link>
      </div>
      {pre.warnings.map((w) => <p key={w} className="text-xs text-[#FFB020]" data-testid="wf-preflight-warning">{w}</p>)}
      <div className="flex gap-2 overflow-x-auto pb-1">
        {pre.steps.map((s, i) => (s.kind === "gate" ? <GateChip key={s.node_id} s={s} i={i} t={trace[s.node_id]} /> : <AgentChip key={s.node_id} s={s} i={i} t={trace[s.node_id]} />))}
      </div>
    </Panel>
  );
};
